module.exports = __webpack_public_path__ + "static/media/Vespiquen_gaussian2.4be96ae2.png";